// extracted by mini-css-extract-plugin
module.exports = {"container":"rEFkj7KVb7StrZeKeTxtD"};